import { Box, CircularProgress, Typography } from '@mui/material';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';

import '../css/processo.css';
import NomeUtil from '../util/NomeUtil';
import ReactComponent from './ReactComponent';
import TableParte from './TableParte';

class PartesProcesso extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            verificaPolo: true,
            render: true,
            renderPartesProcesso: true,
            renderPartes: true,
            registro: computed,
            partes: computed,
            carregouPartes: computed,
            possuiTerceiros: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get partes() {
        const registro = this.registro;
        const partes = {
            ativo: [],
            passivo: [],
            outros: []
        };

        const numeroProcesso = this.registro.processo.numeroCompleto;
        const mapaPartes = this.sessaoStore.mapaProcessosPartesSessao[numeroProcesso];
        const mapaPartesProcesso = new Map();
        mapaPartes?.partes?.forEach((parte) => {
            mapaPartesProcesso.set(parte.codigo, parte);
        });

        if (registro?.detalhes?.partesProcessuais) {
            registro.detalhes.partesProcessuais.map((partesProcesso) => {
                partesProcesso.partes.map((parte, index) => {
                    const p = {};

                    if (index === 0) {
                        p.tipo = partesProcesso.denominacao;
                    }

                    p.polo = partesProcesso.tipoPolo;
                    p.nome = parte.parte.nome;

                    if (parte.parte.nomeSocial) {
                        p.nomeSocial = parte.parte.nomeSocial;
                    } else if (mapaPartesProcesso.has(parte.parte.codigo)) {
                        const parteProcesso = mapaPartesProcesso.get(parte.parte.codigo);

                        if (parteProcesso.nomeSocial) {
                            p.nomeSocial = parteProcesso.nomeSocial;
                        }
                    }

                    if (parte.registroComplementar) {
                        p.registroComplementar = parte.registroComplementar;
                    } else if (mapaPartesProcesso.has(parte.parte.codigo)) {
                        const parteProcesso = mapaPartesProcesso.get(parte.parte.codigo);

                        if (parteProcesso.registroComplementar) {
                            p.registroComplementar = parteProcesso.registroComplementar;
                        }
                    }

                    p.codigo = parte.parte.codigo;

                    if (this.registro.segredoJustica) {
                        p.nomeAbreviado = NomeUtil.abreviarNome(p.nome);
                    }

                    p.representantes = parte.representantes;

                    if (parte.procuradoria) {
                        p.procuradoria = parte.procuradoria.nome;
                    }

                    if (parte.parte.codigoDomicilioEletronico) {
                        p.codigoDomicilioEletronico = parte.parte.codigoDomicilioEletronico;
                    }
                    if (parte.parte.intimacaoDomicilioEletronico) {
                        p.intimacaoDomicilioEletronico = parte.parte.intimacaoDomicilioEletronico;
                    }
                    console.debug('p', p);
                    console.debug('parte', parte);

                    this.verificaPolo(p, partes);
                    return parte;
                });

                return partesProcesso;
            });
        }

        return partes;
    }

    verificaPolo(p, partes) {
        if (p.polo === 'POLO_ATIVO') {
            partes.ativo.push(p);
        } else if (p.polo === 'POLO_PASSIVO') {
            partes.passivo.push(p);
        } else {
            partes.outros.push(p);
        }
    }

    get carregouPartes() {
        return this.partes && this.partes.ativo && this.partes.ativo.length > 0;
    }

    get possuiTerceiros() {
        return this.partes.outros && this.partes.outros.length > 0;
    }

    render() {
        const estiloContainer = { display: 'flex', flexGrow: '2' };
        const estiloContainerVisualizacaoVertical = { display: 'flex' };

        return (
            <div
                style={
                    this.observableProps.visualizacaoVertical ? estiloContainerVisualizacaoVertical : estiloContainer
                }
            >
                {!this.carregouPartes && this.appStore.requisicoesPendentes ? (
                    <div style={{ display: 'flex' }}>
                        <CircularProgress
                            disableShrink={true}
                            style={{ margin: '10px' }}
                        />
                        <Typography
                            sx={{ margin: '5px', paddingTop: '10px' }}
                            variant="subtitle1"
                        >
                            Carregando partes do processo
                        </Typography>
                    </div>
                ) : (
                    this.renderPartesProcesso()
                )}
            </div>
        );
    }

    renderPartesProcesso() {
        return this.observableProps.visualizacaoVertical ? (
            <div
                style={{
                    display: 'flex',
                    flexGrow: '1',
                    flexDirection: 'column',
                    maxHeight: '25vh',
                    ...this.observableProps.visualizacaoVerticalEstilos
                }}
            >
                <div>{this.renderPartes(this.partes.ativo)}</div>
                <div>{this.renderPartes(this.partes.passivo)}</div>
                {!!this.possuiTerceiros && <div>{this.renderPartes(this.partes.outros)}</div>}
            </div>
        ) : (
            <div style={{ display: 'flex', flexGrow: '1' }}>
                <div style={{ width: this.possuiTerceiros ? '33%' : '50%', minHeight: '20vh' }}>
                    {this.renderPartes(this.partes.ativo)}
                </div>
                <div
                    style={{
                        boxShadow: 'rgba(0, 0, 0, 0.4) 2px 0px 0px 0px',
                        width: '1px',
                        margin: '0px 5px',
                        color: 'white'
                    }}
                />
                <div style={{ width: this.possuiTerceiros ? '33%' : '50%' }}>
                    {this.renderPartes(this.partes.passivo)}
                </div>
                {!!this.possuiTerceiros && (
                    <>
                        <div
                            style={{
                                boxShadow: 'rgba(0, 0, 0, 0.4) 2px 0px 0px 0px',
                                width: '1px',
                                margin: '0px 5px',
                                color: 'white'
                            }}
                        />
                        <div style={{ width: '34%' }}>{this.renderPartes(this.partes.outros)}</div>
                    </>
                )}
            </div>
        );
    }

    renderPartes(partes) {
        if (!partes) {
            return null;
        }

        const estiloPartes = { display: 'flex', flexDirection: 'column', minHeight: '10px' };

        return (
            <Box style={{ display: 'flex', flexDirection: 'column', flexGrow: '1', overflowY: 'auto', height: '100%' }}>
                <Box
                    sx={
                        this.observableProps.visualizacaoVertical || this.observableProps.expandido
                            ? estiloPartes
                            : { ...estiloPartes, maxHeight: '10px' }
                    }
                >
                    {partes.map((parte) => (
                        <Box key={parte.codigo}>
                            <TableParte
                                classeAlinhamentoPartes={
                                    this.observableProps.visualizacaoVertical ? 'lista-align lista-disc' : 'lista-align'
                                }
                                ocultarRepresentantes={this.observableProps.ocultarRepresentantes}
                                parte={parte}
                                style={{ color: 'red' }}
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        );
    }
}

export default inject('stores')(observer(PartesProcesso));
